import AppService from "@/services/AppService.js";
const namespaced = true;
const state = {
  lists: {},
  list: {},
  type: {},
  message: {},
  log_details: "",
  details: {},
  code: ""
};
const mutations = {
  SET_DATAS(state, lists) {
    state.lists = lists.tax_list;
  },
  TAX_DETAILS(state, data) {
    state.details = data.data.data;
    state.code = data.status;
  },
  LIST_LOG(state, data) {
    state.log_details = data;
  },
  STATUS_CODE(state, code) {
    state.code = code;
  },
  STATUS_DETAILS(state, data) {
    state.message = data.data.status;
    state.type = data.data.type;
  }
};
const actions = {
  fetchLists({
    commit,
    rootState
  }) {
    return AppService.taxgroup
      .getTaxes(rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_DATAS", response.data.data); // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  fetchDetails({
    commit,
    rootState
  }) {
    return AppService.taxgroup
      .getDetails(rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("TAX_DETAILS", response); // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  createtaxrate({
    commit,
    rootState
  }, data) {
    return AppService.taxgroup
      .posttaxrate(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("STATUS_DETAILS", response);
          commit("STATUS_CODE", response.status);
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  createtaxgroup({
    commit,
    rootState
  }, data) {
    return AppService.taxgroup
      .posttaxgroup(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
        commit("STATUS_DETAILS", response);
        commit("STATUS_CODE", response.status);
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  updatetaxrate({
    commit,
    rootState
  }, {
    id,
    data
  }) {
    return AppService.taxgroup
      .postupdatetaxrate(id, data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
        commit("STATUS_DETAILS", response);
        commit("STATUS_CODE", response.status);
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  updatetaxgroup({
    commit,
    rootState
  }, {
    id,
    data
  }) {
    return AppService.taxgroup
      .postupdatetaxgroup(id, data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
        commit("STATUS_DETAILS", response);
        commit("STATUS_CODE", response.status);
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  viewtaxrate({
    commit,
    rootState
  }, id) {
    return AppService.taxgroup
      .getviewtaxrate(id, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
        commit("STATUS_CODE", response.status);
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  viewtaxgroup({
    commit,
    rootState
  }, id) {
    return AppService.taxgroup
      .getviewtaxgroup(id, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
        commit("STATUS_CODE", response.status);
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  deletetaxrate({
    commit,
    rootState
  }, data) {
    return AppService.taxgroup
      .deletetaxrate(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("LIST_LOG", response.data); // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  deletetaxgroup({
    commit,
    rootState
  }, data) {
    return AppService.taxgroup
      .deletetaxgroup(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("LIST_LOG", response.data); // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  }
};
export default {
  namespaced,
  state,
  mutations,
  actions
};